import { Component, ojs, app, v, eData, payload } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { either, formatThousand, monetary } from "../../helpers";
import { uc, dc } from "../../declarations";

const h = app("h");
const broker = app("broker");
const route = app("router");
const $e = app("$e");

export default class CapaForm extends Component {
	render(...args) {
		return h.div(
			h.h5(
				{ class: "fw-bold mb-3 text-secondary" },
				"Pay From Your Wallet"
			),

			h.div(
				{ class: "card border-0 shadow-sm rounded-4" },
				h.div(
					{ class: "card-body p-4" },
					h.form(
						h.div(
							{ class: "mb-4 text-center" },
							h.small(
								{ class: "text-muted text-uppercase fw-bold" },
								"Processing Amount"
							),
							h.h2(
								{ class: "text-primary fw-bold mt-1" },
								dc.capaSymbol,
								v(uc.currentPaymentAmount, (amount) => {
									let v = amount.value;
									return formatThousand(
										v / (window.systemConfigs.capaExchangeRate ?? 1)
									);
								})
							)
						),

						h.div(
							{
								class: "bg-light rounded-4 p-3 mb-4 d-flex justify-content-between align-items-center",
							},
							h.div(
								h.small(
									{ class: "text-muted d-block mb-1" },
									"Available Balance"
								),
								h.span(
									{ class: "fs-4 fw-bold text-dark" },
									dc.capaSymbol,
									v(uc.capa, (capa) =>
										formatThousand(
											capa?.value?.balance ?? 0
										)
									)
								)
							),
							h.button(
								{
									class: "btn btn-outline-primary rounded-pill btn-sm px-3 fw-bold",
									type: "button",
									onclick: () => app("router").to("/wallet"),
								},
								h.i({ class: "fas fa-plus-circle me-1" }),
								"Buy More"
							)
						),

						h.div(
							{ class: "form-check mb-4" },
							h.input({
								type: "checkbox",
								class: "form-check-input",
								id: "terms-and-condition-capa",
								checked: either(
									localStorage.getItem("paymentTc") == 1,
									true
								),
							}),
							h.label(
								{
									class: "form-check-label text-muted small",
									for: "terms-and-condition-capa",
								},
								"I agree to Carata ",
								h.a(
									{
										href: "https://carata.co/terms-and-conditions/",
										target: "_blank",
										class: "text-decoration-none",
									},
									"Terms and Conditions"
								)
							)
						),

						h.button(
							{
								type: "button",
								class: "btn btn-primary w-100 rounded-pill py-3 fw-bold shadow-sm",
								onclick: this.method("submit"),
							},
							"Pay With Capa"
						)
					)
				)
			)
		);
	}

	submit() {
		let tc = dom.id("terms-and-condition-capa");
		let method = "capa";

		let meta = {};

		for (let [k, v] of route.qs.entries()) {
			meta[k] = v;
		}

		meta.method = method;
		let amount = null;
		if (route.qs.has("editable")) {
			amount = uc.currentPaymentAmount.value;
		}

		broker.broadcast(
			$e.payment.needs.creation,
			eData(meta, {
				paymentData: { capa_id: uc.capa?.value?.id ?? 0 },
				tc: tc?.checked ?? false,
				method,
				amount,
			})
		);
	}
}

ojs(CapaForm);
